// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['coordenador_operacional']


const DEFAULT_URL = '/ncm'

const ncmsBreadCrumb = [
  {
    label: 'Home',
    to: 'Home'
  },
  {
    label: 'NCMs',
    to: 'ncm'
  }
]

export default [
  {
    path: `${DEFAULT_URL}`,
    name: 'ncm',
    component: () => import('@/views/NCM/NcmListPage.vue'),
    meta: {
      roles: ROLES,
      title: 'NCMs',
      breadcrumb: ncmsBreadCrumb
    }
  },
  {
    path: `${DEFAULT_URL}/novo`,
    name: 'ncmsNovo',
    component: () => import('@/views/NCM/NovoNcmPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Novo NCM',
      breadcrumb: [
        ...ncmsBreadCrumb,
        {
          label: 'Novo NCM',
          to: 'ncmsNovo'
        }
      ]
    }
  },
  {
    path: `${DEFAULT_URL}/:id/edit`,
    name: 'ncmsEdit',
    component: () => import('@/views/NCM/NovoNcmPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Detalhes',
      breadcrumb: [
        ...ncmsBreadCrumb,
        {
          label: 'Novo NCM',
          to: 'ncmsNovo'
        }
      ]
    }
  }
]
